<template lang="pug">
	.list-group-control
		ul.list-group
			li.list-group-item(v-for="value in values") {{value}}
				i.fa.fa-times.remove-button(v-on:click="removeValue(value)")
		select.custom-select.custom-select-sm.new-option(v-if="type === 'assets'" v-on:change="updateSetting($event.target.value, $event.target)")
			option(:selected="'true'" value="none") {{'Add new asset' }}
			option(v-for="asset in options" :value="asset.codename") {{asset.codename}}
</template>

<script>

	import Screen 				from './../../../mixins/screen';
	import {Project} 			from './../../../services/Project';
	import {Asset} 				from './../../../services/Asset';
	import {Section} 			from './../../../services/Section';


	export default {
		name: "ListGroupControl",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Setting Changed", "Project Version Settings Changed"]
		},
		props: ["settingValue", "settingName", "type", "section"],
		data() {

			this.Project = Project;
			this.Asset = Asset;
			this.Section = Section;
			//this.values = [];
			return {
				options: [],
				values: [],
				showed: true
			}
		},
		methods: {

			collectData() {
				this.values = this.settingValue;
				if (!this.values) this.values = [];
				console.log('setting', this.values);
				switch (this.type) {
					case 'assets':
						this.options = Object.values(Asset.AssetsByProject[Project.SelectedProject.id]).filter(asset => !this.values.includes(asset.codename));
				}

			},

			updateSetting(value, event) {
				if (value === 'none') return;
				this.values.push(value);
				Section.saveSectionData(this.section, this.settingName, this.values);
				event.selectedIndex = 0;
				this.updateOptions();
			},

			removeValue(value) {
				this.values.splice(this.values.indexOf(value), 1);
				Section.saveSectionData(this.section, this.settingName, this.values);
				this.updateOptions();
			},

			updateOptions() {
				switch (this.type) {
					case 'assets':
						this.options = Object.values(Asset.AssetsByProject[Project.SelectedProject.id]).filter(asset => !this.values.includes(asset.codename));
				}
			}

		}

	}
</script>

<style lang="sass">
	.list-group-control

		width: 100%
		font-size: 0.75rem

		.list-group

			.list-group-item
				background-color: #515b65
				border: 1px solid #23282c
				padding: 2px 6px

				.remove-button
					position: absolute
					right: 5px
					top: 0px
					margin-top: 6px
					cursor: pointer

		select.new-option
			width: 100% !important


</style>
